var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0169 9.47969C27.8669 2.32969 16.1336 2.32969 8.98359 9.47969C1.83359 16.6297 1.83359 28.363 8.98359 35.513C16.1336 42.663 27.6836 42.663 34.8336 35.513C41.9836 28.363 42.1669 16.6297 35.0169 9.47969ZM27.1336 30.1964L22.0003 25.063L16.8669 30.1964L14.3003 27.6297L19.4336 22.4964L14.3003 17.363L16.8669 14.7964L22.0003 19.9297L27.1336 14.7964L29.7003 17.363L24.5669 22.4964L29.7003 27.6297L27.1336 30.1964Z",
    fill: "#EC1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleFill);
export default __webpack_public_path__ + "static/media/x-circle-fill.6f7132fe0ddb4135b607735ce2025164.svg";
export { ForwardRef as ReactComponent };